import { useRef, useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";

const Table = ({
deliveryNoteItems,
status
}) => {
  const tableRef = useRef();
  const dropdownRef = useRef();
  const [offset, setOffset] = useState(0);
  const [item_list, setitem_list] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [search_input, setsearch_input] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [rowsPerPage] = useState(10);
  const [showColumnSettings, setShowColumnSettings] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductModal, setShowProductModal] = useState(false);
  const [tempPickedQty, setTempPickedQty] = useState(0);

  const staticPickListItems = deliveryNoteItems || '';

  

  



  
  // Column configuration with all possible columns
  const [availableColumns, setAvailableColumns] = useState([
    { name: "Action", visible: false, required: true, width: "20px" },
    { name: "S.No", visible: true, required: true, width: "20px" },
    { name: "Item Code", visible: true, width: "100px" },
    { name: "Item Group", visible: false, width: "100px" },
    { name: "Item Name", visible: true, width: "100px" },
    { name: "Quantity", visible: true, width: "50px" },
    { name: "Bin", visible: true, width: "120px" },
    { name: "UOM", visible: false, width: "80px" },
    { name: "Sales Order", visible: false, width: "150px" },
    { name: "Batch No", visible: false, width: "120px" },
    { name: "Description", visible: false, width: "120px" },
    { name: "Original Qty", visible: false, width: "120px" },
    { name: "Available Qty", visible: false, width: "120px" },
  ]);

  // Initialize rows with static pickListItems
useEffect(() => {
  const itemsToUse = deliveryNoteItems || staticPickListItems;
  
  const initialRows = itemsToUse.map(item => ({
    ...item,
    item_code: item.item_code || '',
    item_name: item.item_name || '',
    item_group: item.item_group || '',
    description: item.description || '',
    quantity:
      status === 'Draft'
        ? item.qty || 0
        : item.picked_qty || 0,   
         warehouse: item.warehouse || '',
    uom: item.uom || '',
    sales_order: item.sales_order || '',
    batch_no: item.batch_no || 'N/A',
    original_qty: item.original_qty || 0,
    available_qty: item.available_qty || 0
  }));

  setRows(initialRows);
}, [deliveryNoteItems]);


  // Get visible columns - this is what actually renders
  const visibleColumns = availableColumns.filter(col => col.visible);

  // Toggle column visibility
  const toggleColumnVisibility = (columnName) => {
    setAvailableColumns(prevColumns =>
      prevColumns.map(col =>
        col.name === columnName ? { ...col, visible: !col.visible } : col
      )
    );
  };

  // Handle settings click
  const handleSettingsClick = () => {
    setShowColumnSettings(!showColumnSettings);
  };


  // Table functions
  const handleSelectAll = (e) => {
    setSelectedRows(e.target.checked ? rows.map((_, index) => index) : []);
  };

  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);


  const updateRow = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
 
  };

  const toggleRowSelection = (index) => {
    setSelectedRows(prev =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) setCurrentPage(lastPage);
  };

  useEffect(() => {
  }, []);

  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;

    const handleScroll = () => {
      if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 && hasMore) {
        const newOffset = offset + 20;
        setOffset(newOffset);
      }
    };

    dropdown.addEventListener("scroll", handleScroll);
    return () => dropdown.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, search_input]);

  // useEffect(() => {
  //   const cols = tableRef.current?.querySelectorAll("th") || [];
  //   cols.forEach((col) => {
  //     const resizer = document.createElement("div");
  //     resizer.className = "resizer";
  //     col.appendChild(resizer);

  //     const onMouseDown = (e) => {
  //       const x = e.clientX;
  //       const w = col.offsetWidth;

  //       const onMouseMove = (e) => {
  //         col.style.width = `${w + e.clientX - x}px`;
  //       };

  //       const onMouseUp = () => {
  //         document.removeEventListener("mousemove", onMouseMove);
  //         document.removeEventListener("mouseup", onMouseUp);
  //       };

  //       document.addEventListener("mousemove", onMouseMove);
  //       document.addEventListener("mouseup", onMouseUp);
  //     };

  //     resizer.addEventListener("mousedown", onMouseDown);
  //   });
  // }, [visibleColumns]);

    useEffect(() => {
      const cols = tableRef.current.querySelectorAll("th");
      cols.forEach((col) => {
        const resizer = document.createElement("div");
        resizer.className = "resizer";
        col.appendChild(resizer);
  
        let x = 0;
        let w = 0;
  
        const onMouseDown = (e) => {
          x = e.clientX;
          w = col.offsetWidth;
  
          document.addEventListener("mousemove", onMouseMove);
          document.addEventListener("mouseup", onMouseUp);
        };
  
        const onMouseMove = (e) => {
          const dx = e.clientX - x;
          col.style.width = `${w + dx}px`;
        };
  
        const onMouseUp = () => {
          document.removeEventListener("mousemove", onMouseMove);
          document.removeEventListener("mouseup", onMouseUp);
        };
  
        resizer.addEventListener("mousedown", onMouseDown);
      });
    }, [tableRef,availableColumns]);

  // Modal functions
  const handleEditClick = (row) => {
    setSelectedProduct(row);
    setTempPickedQty(row.picked_qty || 0);
    setShowProductModal(true);
  };

  const handleSaveChanges = () => {
    const updatedRows = rows.map(row => {
      if (row.item_code === selectedProduct.item_code) {
        return { ...row, picked_qty: tempPickedQty };
      }
      return row;
    });
    
    setRows(updatedRows);
    // setselected_item_data(updatedRows);
    // sethaschange(true);
    // setNewRows(updatedRows);
    setShowProductModal(false);
  };

  return (
    <div className="position-relative">
      <table className="table table-bordered mb-1 " ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {visibleColumns.map((column, i) => (
              <th
                key={i}
                style={{
                  fontSize: '7px',
                  position: "relative",
                  textAlign: column.name === "Action" || column.name === "S.No" ? "center" : "center",
                  width: column.width,
                  minWidth: column.width,
                  height: '30px',
                }}
              >
                {column.name === "Action" ? (
                  <input
                    type="checkbox"
                    className="form-check-input"
                    style={{
                      backgroundColor: isAllSelected ? "#270b79" : "",
                      borderColor: isAllSelected ? "#270b79" : "",
                      fontSize: '15px',
                    }}
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                  />
                ) : column.name}
              </th>
            ))}
            {/* Settings column - always visible */}
            <th
              style={{
                fontSize: '7px',
                width: '30px',
                minWidth: '30px',
                cursor: 'pointer'
              }}
              onClick={handleSettingsClick}
            >
              <GetIcon iconName="IoSettingsOutline" size={14} />
            </th>
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            console.log("check row is here",row);
            return (
              <tr key={globalIndex}>
                {visibleColumns.map((column, colIndex) => {
                  switch (column.name) {
                    case "Action":
                      return (
                        <td className="p-0" style={{ cursor: 'pointer',    height: '30px', }} key={colIndex}>
                          <p className="m-0" style={{ position: 'relative', top: "5px" }}>
                            {selectedRows.includes(globalIndex) ? (
                              <span onClick={() => toggleRowSelection(globalIndex)}>
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  style={{ backgroundColor: "#270b79", fontSize: '15px', borderColor: '#270b79' }}
                                  checked
                                />
                              </span>
                            ) : (
                              <span onClick={() => toggleRowSelection(globalIndex)}>
                                <input type="checkbox" className="form-check-input" style={{ fontSize: '15px' }} />
                              </span>
                            )}
                          </p>
                        </td>
                      );
                    case "S.No":
                      return (
                        <td
                          key={colIndex}
                          style={{
                            textAlign: "center",
                            fontSize: '0.8rem',
                            padding: '0.5rem',
                            height: '30px',
                          }}
                        >
                          {globalIndex + 1}
                        </td>
                      );
                    case "Item Code":
                      return (
                        <td className="p-0" style={{ position: "relative" ,   height: '30px',}} key={colIndex}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem',   height: '30px',                            textAlign: "center",
 }}
                            onFocus={() => setShowDropdown(globalIndex)}
                            onBlur={() => setTimeout(() => setShowDropdown(false), 300)}
                            onChange={(e) => {
                              setsearch_input(e.target.value);
                              setOffset(0);
                              // getItemdata(0, e.target.value);
                              updateRow(globalIndex, "item_code", e.target.value);
                            }}
                            value={row.item?.item_code || row.item_code}
                            readOnly={true}
                          />
                        </td>
                      );
                    case "Item Name":
                      return (
                        <td className="p-0" key={colIndex} style={{height : '30px'}}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem',   height: '30px',                            textAlign: "center",
 }}
                            readOnly
                            value={row.item?.item_name || row.item_name}
                          />
                        </td>
                      );
                    case "Item Group":
                      return (
                        <td className="p-0" key={colIndex}  style={{height : '30px',                            textAlign: "center",
}}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem',   height: '30px', }}
                            readOnly
                            value={row.item?.item_group || ''}
                          />
                        </td>
                      );
                    case "Quantity":
                      return (
                        <td className="p-0" key={colIndex} style={{   height: '30px',}}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem',   height: '30px',                             textAlign: "center",
}}
                            min={1}
                            value={row.quantity}
                            onChange={(e) => {
                              const value = parseInt(e.target.value);
                              if (value >= 1 || e.target.value === '') {
                                updateRow(globalIndex, "quantity", e.target.value);
                              }
                            }}
                          />
                        </td>
                      );
                    case "Pick Quantity":
                      return (
                        <td className="p-0" key={colIndex}
                          style={{ outline: 'none' ,   height: '30px',}}
                          onFocus={(e) => e.currentTarget.style.backgroundColor = '#e6f7ff'}
                          onBlur={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                          tabIndex={-1}
                        >
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem' ,   height: '30px',                            textAlign: "center",
}}
                            min={0}
                            max={row.quantity}
                            value={row.picked_qty || 0}
                            onChange={(e) => {
                              const value = parseInt(e.target.value);
                              if ((value >= 0 && value <= row.quantity) || e.target.value === '') {
                                updateRow(globalIndex, "picked_qty", e.target.value);
                              }
                            }}
                          />
                        </td>
                      );
                    case "Bin":
                      return (
                        <td className="p-0" key={colIndex} style={{   height: '30px',}}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem',   height: '30px',                            textAlign: "center",
 }}
                            readOnly
                            value={row.warehouse}
                          />
                        </td>
                      );
                    case "UOM":
                      return (
                        <td className="p-0" key={colIndex} style={{   height: '30px',}}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem' ,   height: '30px',                            textAlign: "center",
}}
                            readOnly
                            value={row.uom}
                          />
                        </td>
                      );
                    case "Sales Order":
                      return (
                        <td className="p-0" key={colIndex} style={{   height: '30px',                            textAlign: "center",
}}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem',   height: '30px',textAlign:'center'}}
                            readOnly
                            value={row.sales_order}
                          />
                        </td>
                      );
                    case "Batch No":
                      return (
                        <td className="p-0" key={colIndex} style={{   height: '30px',}}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem' ,   height: '30px',                            textAlign: "center",
}}
                            readOnly
                            value={row.batch_no || 'N/A'}
                          />
                        </td>
                      );
                    case "Description":
                      return (
                        <td className="p-0" key={colIndex} style={{   height: '30px',                            textAlign: "center",
}}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem',   height: '30px', }}
                            readOnly
                            value={row.description || 'N/A'}
                          />
                        </td>
                      );
                    case "Original Qty":
                      return (
                        <td className="p-0" key={colIndex} style={{   height: '30px',                            textAlign: "center",
}}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem' ,   height: '30px',}}
                            readOnly
                            value={row.original_qty || 'N/A'}
                          />
                        </td>
                      );
                    case "Available Qty":
                      return (
                        <td className="p-0" key={colIndex} style={{   height: '30px',                            textAlign: "center",
}}>
                          <input
                            type="text"
                            className="form-control tableinput noborder"
                            style={{ fontSize: '0.8rem',   height: '30px', }}
                            readOnly
                            value={row.available_qty || 'N/A'}
                          />
                        </td>
                      );
                    default:
                      return null;
                  }
                })}
                <td onClick={() => handleEditClick(row)} style={{   height: '30px',                            textAlign: "center",
}}>  
                  <GetIcon iconName="MdOutlineEdit" size={15} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Column Settings Popup */}
      {showColumnSettings && (
        <div className="modal-backdrop" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div className="card " style={{
            width: '551px',
            zIndex: 1000,
            maxHeight: '80vh',
            display: 'flex',
            flexDirection: 'column'
          }}>
            {/* Header */}
            <div className="pt-3 px-4 d-flex justify-content-between align-items-center ">
              <div>
                <h6 className="m-0 fw-semibold mb-1"  style={{ fontWeight: '800' ,fontSize : "20px"}}>Pick List Fields</h6>
                <p className="m-0 text-muted small" style={{fontSize : '13px'}}>+ Add / Remove Fields</p>
              </div>
              <button
                className="btn btn-sm btn-close"
                onClick={() => setShowColumnSettings(false)}
                aria-label="Close"
              />
            </div>

            {/* Body - Checkbox List */}
            <div className=" p-0" style={{ overflowY: 'auto' }}>
              <div className="p-4">
                <div className="row" style={{gap :'5px'}}>
                  {availableColumns.map((column, index) => (
                    !column.required && (
                      <div key={index} className="col-sm-6" style={{width : '157px'}}>
                        <div className="form-check d-flex align-items-center">
                          <input
                            className="form-check-input me-2"
                            type="checkbox"
                            style={{ fontSize: '12px',width : '12px',height : '12px',borderRadius :'3px', backgroundColor: '#270B79', borderColor: "#270B79" }}
                            id={`col-${index}`}
                            checked={column.visible}
                            onChange={() => toggleColumnVisibility(column.name)}
                          />
                          <label
                            className="form-check-label text-truncate"
                            htmlFor={`col-${index}`}
                            style={{
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                            title={column.name}
                          >
                            {column.name}
                          </label>
                        </div>
                      </div>
                    )
                  ))}
                </div>
              </div>
            </div>

            <div className="py-3 px-4  d-flex justify-content-end gap-3">
              <div className="modal-footer px-6" style={{ borderTop: "0px" }}>
                <p className="createbtn m-0 px-4" onClick={() => setShowColumnSettings(false)}>
                  Save
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Product Edit Modal */}
      {showProductModal && selectedProduct && (
        <div className="modal-backdrop" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <div className="card shadow-sm" style={{
            width: '800px',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column'
          }}>
            {/* Modal Header */}
            <div className="card-header py-3 d-flex justify-content-between align-items-center ">
              <h5 className="m-0 modal-title">Edit Item - {selectedProduct.item_code}</h5>
                <button 
              style={{ color: 'black', border: 'none', background: 'transparent', fontSize: '1.2rem', cursor: 'pointer' }}
              onClick={() => setShowProductModal(false)}
              aria-label="Close"
            >
              &times;
            </button>
            </div>

            {/* Modal Body */}
            <div className="card-body" style={{ overflowY: 'auto' }}>
              <div className="row">
                {/* First Row */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Item Code</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      style={{ fontSize: '0.8rem' }} 
                      value={selectedProduct.item_code} 
                      readOnly 
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Item Name</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      style={{ fontSize: '0.8rem' }} 
                      value={selectedProduct.item?.item_name || selectedProduct.item_name} 
                      readOnly 
                    />
                  </div>
                </div>
                
                {/* Second Row */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Item Group</label>
                    <input 
                      type="text" 
                      style={{ fontSize: '0.8rem' }} 
                      className="form-control" 
                      value={selectedProduct.item?.item_group || 'N/A'} 
                      readOnly 
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Description</label>
                    <input 
                    style={{ fontSize: '0.8rem' }} 
                      type="text" 
                      className="form-control" 
                      value={selectedProduct.description || 'N/A'} 
                      readOnly 
                    />
                  </div>
                </div>
                
                {/* Third Row */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Quantity</label>
                    <input 
                    style={{ fontSize: '0.8rem' }} 
                      type="number" 
                      className="form-control" 
                      value={selectedProduct.quantity} 
                      readOnly 
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Pick Quantity</label>
                    <input 
                      type="number" 
                      style={{ fontSize: '0.8rem' }} 
                      className="form-control" 
                      value={tempPickedQty}
                      onChange={(e) => {
                        const value = parseInt(e.target.value);
                        if (!isNaN(value)) {
                          setTempPickedQty(Math.min(Math.max(value, 0), selectedProduct.quantity));
                        }
                      }}
                      min={0}
                      max={selectedProduct.quantity}
                    />
                  </div>
                </div>
                
                {/* Fourth Row */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Warehouse</label>
                    <input 
                    style={{ fontSize: '0.8rem' }} 
                      type="text" 
                      className="form-control" 
                      value={selectedProduct.warehouse} 
                      readOnly 
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>UOM</label>
                    <input 
                    style={{ fontSize: '0.8rem' }} 
                      type="text" 
                      className="form-control" 
                      value={selectedProduct.uom} 
                      readOnly 
                    />
                  </div>
                </div>
                
                {/* Fifth Row */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Sales Order</label>
                    <input 
                    style={{ fontSize: '0.8rem' }} 
                      type="text" 
                      className="form-control" 
                      value={selectedProduct.sales_order || 'N/A'} 
                      readOnly 
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Batch No</label>
                    <input 
                    style={{ fontSize: '0.8rem' }} 
                      type="text" 
                      className="form-control" 
                      value={selectedProduct.batch_no || 'N/A'} 
                      readOnly 
                    />
                  </div>
                </div>
                
                {/* Sixth Row */}
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Original Quantity</label>
                    <input 
                    style={{ fontSize: '0.8rem' }} 
                      type="text" 
                      className="form-control" 
                      value={selectedProduct.original_qty || 'N/A'} 
                      readOnly 
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label" style={{ fontSize: '0.8rem' }}>Available Quantity</label>
                    <input 
                    style={{ fontSize: '0.8rem' }} 
                      type="text" 
                      className="form-control" 
                      value={selectedProduct.available_qty || 'N/A'} 
                      readOnly 
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="card-footer d-flex justify-content-end gap-2">
              <p onClick={handleSaveChanges} style={{ textDecoration: "none", cursor: "pointer" }} className="custom-btn-00989 m-0"> Save </p>
            </div>
          </div>
        </div>
      )}

      {/* Pagination Controls */}
      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          {/* {selectedRows.length > 0 && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn"
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}

          <Button
            className="createbtn d-flex"
            style={{ gap: '2px', height: '28px' }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
          >
            Download
          </Button> */}
        </div>

        {/* Pagination */}
        <div className={`${rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default Table;